import { useApp } from '../../app/context';
import { ru } from '../../i18n/ru';
import './ConnectionBanner.css';

/**
 * Small pill at the top while (re)connecting. It fades in after a short delay (CSS), so a
 * quick reconnect never flashes it.
 */
export function ConnectionBanner() {
  const status = useApp().connection.status.value;
  const text =
    status === 'connecting' || status === 'reconnecting' ? ru.connection.banner[status] : null;
  if (!text) return null;
  return (
    <div class={`conn-banner conn-banner--${status}`} role="status">
      <span class="conn-banner__spinner" aria-hidden="true" />
      {text}
    </div>
  );
}
